// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dyftqspuiyabqzjslwyw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR5ZnRxc3B1aXlhYnF6anNsd3l3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM0MjA5MzIsImV4cCI6MjA2ODk5NjkzMn0.mibvMCccmDDhYCg7JY42pyc9dXjnYWWE32lVrv25V-U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});